import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

import HTMLView from 'Components/HTMLView';

import BaseExamItemWrapper from '../ExamItemWrapper';

const ExamItemWrapper = styled(BaseExamItemWrapper)`
  ${({ theme }) => css`
    padding: ${theme.space[6]}px;
    @media (max-width: ${theme.breakpoints[1]}) {
      padding: ${theme.space[4]}px ${theme.space[6]}px;
    }
  `}
`;

const ExamArticle = (props) => {
  const { article, containerClassName } = props;
  return (
    <ExamItemWrapper className={containerClassName}>
      <HTMLView rawContent={article} />
    </ExamItemWrapper>
  );
};

ExamArticle.propTypes = { article: PropTypes.string, containerClassName: PropTypes.string };

export default ExamArticle;
